/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { ICreateCachedItemHospModsResponse, IModsPriceCalculationCriteria } from '../custom-actions/DataServiceEntities.g';
import { getRestItemIdModifiersAsync } from '../custom-actions/DataActionExtension.g';

/**
 * GetProductModifiers Input Action
 */
export class GetProductModifiersInput implements Msdyn365.IActionInput {
    public itemId: string;
    public priceCalculationCriteria: IModsPriceCalculationCriteria = {};
    constructor(itemId: string, priceCalculationCriteria?: IModsPriceCalculationCriteria) {
        this.itemId = itemId;
        this.priceCalculationCriteria = priceCalculationCriteria || {};
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GETPRODUCTMODIFIERS`;
    public getCacheObjectType = () => 'GETPRODUCTMODIFIERS';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getProductModifiersAsync(
    input: GetProductModifiersInput,
    ctx: Msdyn365.IActionContext
): Promise<ICreateCachedItemHospModsResponse> {
    if (ctx.requestContext.query?.q) {
        console.log('q', ctx.requestContext.query?.q);
    }
    try {
        const result = await getRestItemIdModifiersAsync({ callerContext: ctx }, input.itemId, input.priceCalculationCriteria);
        if (result) {
            console.log(result, 'Amar');
            return result;
        }
    } catch (error) {
        console.log('Error', error);
    }
    return {};
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICreateCachedItemHospModsResponse>>getProductModifiersAsync,
    id: 'GetProductModifiers'
});
